import { css, cx } from '@fable/theme'
import { StreamChart } from './StreamChart'
import { ChartLegend } from '../../chart_legend'
import { useChartData } from '../hooks/useChartData'
import { useStatsTheme } from 'app/webview/pages/stats_profile/theme/ctx'

export const GenreStreamChartContent = () => {
  const theme = useStatsTheme((s) => s.theme)
  const { genreColors, isZeroState } = useChartData()
  const offset = 12 * 15

  const legendItems = Object.entries(genreColors)
    .map(([genre, color]) => ({
      label: genre,
      color: color || theme.colors.section.bgSecondary,
    }))
    .reverse()

  return (
    <div
      className={css`
        padding: 20px 0 10px;
        width: calc(100% + 32px);
        position: relative;
        left: -16px;
      `}
    >
      <div
        className={css`
          width: 100%;
          position: relative;
          overflow: hidden;
        `}
      >
        <div
          className={css`
            width: 100%;
            padding: 0 10px;
            overflow-x: scroll;
            overflow-y: hidden;
            -ms-overflow-style: none;
            scrollbar-width: none;
            &::-webkit-scrollbar {
              display: none;
            }
          `}
        >
          <div
            className={css`
              width: calc(100% + ${offset}%);
            `}
          >
            <div
              className={css`
                width: 100%;
                height: 200px;
              `}
            >
              <StreamChart />
            </div>
          </div>
        </div>
        <span
          className={cx(
            'anim__genre-stream-cover',
            css`
              width: 100%;
              height: 200px;
              background-color: ${theme.colors.section.bg};
              position: absolute;
              top: 0;
              left: 0;
              z-index: 1;
              pointer-events: none;
              will-change: transform;
            `
          )}
        />
      </div>
      {isZeroState ? null : (
        <ChartLegend
          className={css`
            padding: 20px 16px 0;
          `}
          items={legendItems}
        />
      )}
    </div>
  )
}
